if (!customElements.get('scroll-to-top')) {
  class ScrollToTop extends HTMLElement {
    constructor() {
      super();

      this.buttonScroll = this.querySelector('[data-button-scroll]');

      this.buttonScroll.addEventListener('click', (e) => {
        e.preventDefault();

        window.scrollTo(0, 0);
      });
    }
  }

  customElements.define('scroll-to-top', ScrollToTop);
}
